<div class="min-h-screen flex justify-center">
  <div class="flex flex-col place-content-center text-center p-8">
    <p class="text-base font-semibold text-primary">403</p>
    <h1 class="mt-4 text-5xl sm:text-7xl font-semibold">
      {{ 'forbidden.title' | translate }}
    </h1>
    <p class="mt-6 text-lg font-medium text-pretty text-muted-foreground sm:text-xl/8">
      {{ 'forbidden.subtitle' | translate }}
    </p>
  </div>
</div>